import { useTranslations } from "next-intl";
import Link from "../../core/Link";

function AutonomousLinks() {
  const t = useTranslations("common");

  return (
    <div className="d-flex flex-column">
      <Link
        href="/about"
        className="font-size-sm text-dark font-weight-light"
      >
        {t("footer.about")}
      </Link>
      <Link
        href="/contact-us"
        className="font-size-sm text-dark font-weight-light"
      >
        {t("footer.contact")}
      </Link>

      {t.rich("footer.help_center.text", {
        link: (chunks) => (
          <a
            href={t("footer.help_center.href")}
            target="_blank"
            className="font-size-sm text-dark font-weight-light"
          >
            {chunks}
          </a>
        ),
      })}
    </div>
  );
}

export default AutonomousLinks;
